import { FormikProvider, useFormik } from 'formik';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import FormikPasswordInput from '@perpay-web/components/base/PasswordInput/FormikPasswordInput';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import { passwordSchema } from '@perpay-web/validators/formBased';
import { validateForm } from '@perpay-web/validators/formBased';

import styles from './PasswordForm.scss';

const PasswordForm = ({
    initialValues = {
        password: '',
    },
    buttonText,
    onSubmit,
    errors,
    // Legacy multiple classname prop. Do not duplicate this pattern.
    // https://perpay.atlassian.net/wiki/spaces/PERPAY/pages/3282567207/Components+should+own+their+own+styles
    // eslint-disable-next-line @perpay-web/no-multiple-classname-props
    footerClassName = '',
    // Legacy multiple classname prop. Do not duplicate this pattern.
    // https://perpay.atlassian.net/wiki/spaces/PERPAY/pages/3282567207/Components+should+own+their+own+styles
    // eslint-disable-next-line @perpay-web/no-multiple-classname-props
    contentClassName = '',
    loading = false,
}) => {
    const formik = useFormik({
        initialValues,
        onSubmit: (values) => {
            onSubmit(values.password);
        },
        validate: (values) => validateForm(values, passwordSchema),
    });
    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} className={styles.form}>
                <LegacyFocusLayout
                    contentClassName={contentClassName}
                    footerClassName={footerClassName || styles.footer}
                    footer={
                        <CustomButton
                            type='submit'
                            loading={loading}
                            className={styles.button}
                        >
                            {buttonText || 'Set password'}
                        </CustomButton>
                    }
                >
                    <FormikPasswordInput
                        errors={errors}
                        name='password'
                        showPasswordIndicator
                    />
                    <NonFieldErrors errors={errors} className={styles.error} />
                </LegacyFocusLayout>
            </form>
        </FormikProvider>
    );
};
export default PasswordForm;
